import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M7.795 17.5a3.32 3.32 0 0 0 2.205.833 3.32 3.32 0 0 0 2.205-.834M15 6.666a5 5 0 0 0-10 0c0 2.575-.65 4.338-1.375 5.505-.612.983-.918 1.475-.907 1.612.013.152.045.21.167.301.11.082.61.082 1.606.082H15.51c.996 0 1.495 0 1.606-.082.122-.09.154-.149.166-.3.012-.138-.294-.63-.906-1.614C15.65 11.005 15 9.242 15 6.667"
    }, null, -1)
  ])))
}
export default { render: render }